import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import ClinicalEndpoints from 'bz-pronto-core/endpoints/clinical';
import GUID from 'bz-utilities/modules/variables/guid';

import { MenuItem } from '@material-ui/core';

interface IProps {
  name: string;
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class ReportMenuItem extends React.Component<IProps> {
  render() {
    if (!this.show) return null;

    return (
      <MenuItem onClick={this.onClick} style={{ whiteSpace: 'break-spaces' }}>
        {this.label}
      </MenuItem>
    );
  }

  @computed
  get show() {
    let { name, clinicalStore } = this.props;
    let { allowed, templates } = clinicalStore.prontoStore;
    let templateId = allowed.get(name);

    return allowed.has(name) && GUID.hasValue(templateId) && templates.has(templateId);
  }

  @computed
  get label() {
    let { name, clinicalStore } = this.props;
    let { allowed, templates } = clinicalStore.prontoStore;
    let templateId = allowed.get(name);

    return templates.get(templateId).title;
  }

  @action.bound
  onClick() {
    let { name, clinicalStore } = this.props;
    let { caseStore, prontoStore, historyStore } = clinicalStore;
    let { allowed, bookerId } = prontoStore;
    //create case if does not exist
    let req = {
      bookerId: bookerId,
      caseId: caseStore.id,
      templateId: allowed.get(name)
    };

    ClinicalEndpoints.onCreate(req).then((res: any) => {
      let { reports, treatment } = res;

      prontoStore.onMerge(reports);
      historyStore.create(treatment);
    });
  }
}

export default ReportMenuItem;
